var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleflower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.99 124.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7a2a89;}.cls-2{fill:#edeb73;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.2,110.44,77.41,107.9,68.06,117c-14.68,14.29-39.37,5.54-41.78-14.8l-1.54-13L13.2,83.12C-4.92,73.58-4.23,47.4,14.37,38.82l11.84-5.47L28.43,20.5C31.91.31,57-7.12,70.93,7.91l8.85,9.58L92.7,15.63C113,12.7,127.8,34.28,117.8,52.16l-6.38,11.38,5.77,11.71C126.24,93.66,110.29,114.44,90.2,110.44Z",
    transform: "translate(-0.01 0.04)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.61,
    cy: 63.38,
    r: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleflower);
export default __webpack_public_path__ + "static/media/purple flower.981116e5.svg";
export { ForwardRef as ReactComponent };